import hyRequest from '@/service';
import { IFeedingData } from './type';

enum DashboardApi {
  getFeedingData = '/feed/feedSearchByTime'
}

// 获取进料记录
export function getFeedingData(data: {
  startTime: string;
  endTime: string;
  pageNumber: number;
  pageSize: number;
  condition?: string;
  type?: number;
}) {
  return hyRequest.post<IFeedingData>({
    url: DashboardApi.getFeedingData,
    data
  });
}
